import { TreeProgramTopHeader } from 'components/common';
import { excellenceAppsConfig } from 'components/Dashboards/ExcellenceApps/excellenceAppsConfig';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { ActivitiesTable } from 'components/widgets/ActivitiesTable/ActivitiesTable';
import { ShareInsightButton } from 'components/common/ShareInsightButton/ShareInsightButton';
import { LogicQualityCheckActionsMenu } from 'components/widgets/LogicQualityCheckActionsMenu/LogicQualityCheckActionsMenu';
import { useFullStoryPageView } from 'hooks/useFullstoryPageView';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import { MainCardRoutingModal } from 'components/common/MainCardRoutingModal/mainCardRoutingModal';
import { LogicQualityCheckSelectedFilters } from 'components/widgets/LogicQualityCheckSelectedFilter/LogicQualityCheckSelectedFilters';
import { useLogicCheckerBreadCrumbs } from 'hooks/useLogicCheckerBreadCrumbs';
import { Breadcrumbs } from 'components/common/Breadcrumbs/Breadcrumbs';

export const LogicQualityCheckActivitiesPage = () => {
    useFullStoryPageView({ pageName: excellenceAppsConfig.logicQualityCheck.title });
    const { breadcrumbs } = useLogicCheckerBreadCrumbs({ displayLevel3Activities: true });

    return (
        <PageContainer>
            <HeaderWrapper>
                <TreeProgramTopHeader pageTitle={excellenceAppsConfig.logicQualityCheck.title}>
                    <ShareInsightButton
                        title={excellenceAppsConfig.logicQualityCheck.title}
                        link={window.location.href}
                    />
                    <LogicQualityCheckActionsMenu />
                </TreeProgramTopHeader>
                <Breadcrumbs list={breadcrumbs} />
            </HeaderWrapper>
            <MainContent>
                <LogicQualityCheckSelectedFilters />
                <ActivitiesTable />
            </MainContent>

            <MainCardRoutingModal queryKeys={['getRowDrillDownActivities', 'getValidationActivitiesDrillDown']} />
        </PageContainer>
    );
};
